"use client";

import React from "react";
import { createPortal } from "react-dom";
import { useState, useEffect, useCallback, useRef } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./msalConfig"; // Ensure you have this config file set up
import bbImage from "../../assests/images/bbb.png";
import {
  Eye,
  EyeOff,
  Mail,
  Lock,
  User,
  Building,
  Sparkles,
  Briefcase,
  TrendingUp,
  Loader2,
} from "lucide-react";
import "./signUp.css";
// import "./SocialCompletionModal.css";
// import Logo from "../layout/Logo";

import {
  loginApi,
  signUp,
  getGoogleUserProfile,
  getMicrosoftUserProfile,
} from "../../services/authService";

import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";

export default function ForgotPasscode() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { login } = useAuth();
  const { signup } = useAuth();

  const [isSignUpMode, setIsSignUpMode] = useState(false);
  const [isLoggedin, setIsLoggedin] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    password: "",
    website: "",
    checked: false,
  });
  const [showModal, setShowModal] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  // Add this temporary state for testing
  const [showCompletionModal, setShowCompletionModal] = useState(false); // Set to true for testing
  const [socialUserData, setSocialUserData] = useState({
    name: "John Doe",
    email: "john@example.com",
  });

  useEffect(() => {
    setIsAnimated(true);
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckboxChange = (e) => {
    setFormData({
      ...formData,
      checked: e.target.checked,
    });
  };

  const handleSocialSignupComplete = useCallback(async (completionData) => {
    setIsLoading(true);
    try {
      console.log("Completion data:", completionData);

      // Here you would normally call your signup API
      // For testing, just simulate success
      setTimeout(() => {
        setShowCompletionModal(false);
        setIsLoading(false);
        console.log("Modal would close and redirect to dashboard");
        // navigate("/home")
      }, 2000);
    } catch (error) {
      console.error("Signup completion error:", error);
      setIsLoading(false);
    }
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowCompletionModal(false);
  }, []);

  // API CALLS
  const handleLogin = async (e) => {
    e.preventDefault();
    // Prevent multiple submissions
    if (formData.email === "" || formData.password === "") {
      setShowModal({
        show: true,
        type: "error",
        title: "Missing Fields",
        message: "Please fill in all fields.",
      });
      return;
    }
    setIsLoading(true);
    try {
      const payload = {
        authType: "INTERNAL",
      };
      console.log("Submitting Login:", payload);
      // Make API request
      const response = await loginApi(payload);

      login(response); // Use the login function from AuthContext
      // sessionStorage.setItem("isFirstTimeUser", response.data.isSetupCompleted);

      navigate("/home");
    } catch (error) {
      console.error("Login error:", error);
      // handleApiError(error, { showModal: true });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    console.log("Sign Up clicked", formData);

    // Set loading state
    setIsLoading(true);
    try {
      sessionStorage.clear();
      const payload = {
        adminEmail: formData.email,
        adminName: formData.name,
        adminOrg: formData.organization,
        authType: "INTERNAL",
        website: formData.website,
      };

      const response = await signUp(payload);

      signup(response); // Use the signUp function from AuthContext
      console.log("Sign Up response:", response);

      // Mark as first time user for onboarding
      // sessionStorage.setItem("isFirstTimeUser", response.data.isSetupCompleted);
      navigate("/home");
    } catch (error) {
      console.error("Sign Up error:", error);
      // handleApiError(error, setShowModal, navigate);
    } finally {
      setIsLoading(false);
    }
  };
  const [socialSignupData, setSocialSignupData] = useState({});
  const isSafari =
    typeof navigator !== "undefined" &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // Use one stable callback path for every environment
  const redirectUri = `${window.location.origin}/auth/google/callback`;
  // const loginWithGoogle = useGoogleLogin({
  //   onSuccess: async (tokenResponse) => {
  //     try {
  //       const userInfo = await getGoogleUserProfile(tokenResponse.access_token);
  //       // console.log("Google User Info:", userInfo.data);
  //       setSocialSignupData({
  //         email: userInfo.data.email,
  //         name: userInfo.data.name,
  //         // picture: userInfo.data.picture,
  //       });

  //       const obj = {
  //   //         authType: "GOOGLE",
  //       };
  //       const loginUserDetails = await loginApi(obj);
  //       console.log("Login User Details:", loginUserDetails);

  //       if (loginUserDetails.code == 200) {
  //         login(loginUserDetails); // Use the login function from AuthContext
  //         navigate("/home");
  //       }
  //     } catch (error) {
  //       console.error("Google login error:", error);
  //       handleApiError(error, { showModal: false });

  //       if (error.code == 400 && error.message == "User not found") {
  //         console.log("User not found, showing completion modal");
  //         // Handle user not found case
  //         setSocialUserData({
  //           email: socialSignupData.email,
  //           name: socialSignupData.name,
  //         });
  //         setShowCompletionModal(true);

  //         return;
  //       }
  //     }
  //   },
  //   onError: (err) => {
  //     console.error("Google login failed:", err);
  //   },
  // });

  const loginWithGoogle = useGoogleLogin({
    // Safari may block popups; let it fall back to redirect.
    // Popup remains for Chrome/Edge/Firefox.
    ux_mode: isSafari ? "redirect" : "popup",
    // IMPORTANT: must be whitelisted in Google Console (Authorized redirect URIs)
    redirect_uri: redirectUri,
    // Optional: show account chooser each time
    prompt: "select_account",

    onSuccess: async (tokenResponse) => {
      try {
        const userInfo = await getGoogleUserProfile(tokenResponse.access_token);

        setSocialSignupData({
          email: userInfo.data.email,
          name: userInfo.data.name,
          // picture: userInfo.data.picture,
        });

        const obj = {
          authType: "GOOGLE",
        };

        const loginUserDetails = await loginApi(obj);
        console.log("Login User Details:", loginUserDetails);

        if (loginUserDetails.code === 200) {
          login(loginUserDetails); // AuthContext
          navigate("/home");
        }
      } catch (error) {
        console.error("Google login error:", error);
        // handleApiError(error, { showModal: false });

        // New user → open completion modal
        if (error.code === 400 && error.message === "User not found") {
          setSocialUserData({
            email: socialSignupData.email,
            name: socialSignupData.name,
          });
          setShowCompletionModal(true);
          return;
        }
      }
    },

    onError: (err) => {
      console.error("Google login failed:", err);
    },
  });
  const handleMsAlLogin = async () => {
    try {
      const response = await instance.loginPopup(loginRequest);

      const accessToken = response.accessToken;
      const MsUserProfile = await getMicrosoftUserProfile(accessToken);
      console.log("Microsoft User Profile:", MsUserProfile);
      setSocialSignupData({
        email: MsUserProfile.mail,
        name: MsUserProfile.displayName,
      });
      const obj = {
        authType: "MICROSOFT",
      };
      const loginUserDetails = await loginApi(obj);
      if (loginUserDetails.code == 200) {
        login(loginUserDetails); // Use the login function from AuthContext
        navigate("/home");
      }
      // sessionStorage.setItem("isFirstTimeUser", response.data.isSetupCompleted);
    } catch (error) {
      console.error("MSAL Login error:", error);
      // handleApiError(error, { showModal: false });

      if (error.code == 400 && error.message == "User not found") {
        console.log("User not found, showing completion modal");
        // Handle user not found case
        setSocialUserData({
          email: socialSignupData.mail,
          name: socialSignupData.displayName,
        });
        setShowCompletionModal(true);

        return;
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSignUpMode) {
      handleSignUp(e);
    } else {
      handleLogin(e);
    }
  };

  const [email, setEmail] = useState("");

  return (
    <div className="auth-main-container">
      {/* Subtle Background Effects */}
      <div
        className="auth-bg-dynamic"
        style={{
          background: `radial-gradient(300px circle at ${mousePos.x}px ${mousePos.y}px, rgba(14, 24, 34, 0.08), transparent 40%)`,
        }}
      ></div>

      <div className="auth-bg-elements">
        <div className="auth-floating-orb auth-orb-1"></div>
        <div className="auth-floating-orb auth-orb-2"></div>
      </div>

      <div className="auth-content-wrapper">
        {/* Left Side - Prominent Image & Content */}
        <div className="auth-showcase-section">
          {/* Prominent Image Display */}
          <div className="auth-image-display">
            <div className="auth-image-frame">
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/auth-HmXZj5A6u97g3wKvYIeYQvoN9EAw5m.png"
                alt="Talent Console Platform"
                className="auth-main-image"
              />
              <div className="auth-image-glow"></div>
            </div>
          </div>

          {/* Content Below Image */}
          <div className="auth-content-section">
            <div className="auth-brand-header">
              <div className="auth-logo-container">
                {/* <Logo width={70} height={35} className="auth-logo" /> */}
              </div>
              <h2 className="auth-brand-title">Talent Console</h2>
              <p className="auth-brand-description">
                AI-Powered Talent Management Platform
              </p>
            </div>

            <div className="auth-features-list">
              <div className="auth-feature">
                <div className="auth-feature-icon">
                  <Sparkles size={18} />
                </div>
                <div className="auth-feature-content">
                  <h4>AI-Powered Insights</h4>
                  <p>Advanced analytics for talent decisions</p>
                </div>
              </div>
              <div className="auth-feature">
                <div className="auth-feature-icon">
                  <Briefcase size={18} />
                </div>
                <div className="auth-feature-content">
                  <h4>Workforce Planning</h4>
                  <p>Identify future roles & skills gaps</p>
                </div>
              </div>
              <div className="auth-feature">
                <div className="auth-feature-icon">
                  <TrendingUp size={18} />
                </div>
                <div className="auth-feature-content">
                  <h4>Growth Analytics</h4>
                  <p>Track performance & development</p>
                </div>
              </div>
              <div className="securedContainer">
                <p>Secured by </p>
                <img src={bbImage} />
                <img src="https://piiguard.com/assets/img/pii-guard-logo-white.svg" />
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Compact Form */}
        <div className="auth-form-section">
          <div
            className={`auth-form-container ${
              isAnimated ? "auth-animate-in" : ""
            }`}
          >
            {/* Form Header */}
            <div className="auth-header">
              <h1 className="auth-title">
                {/* {isSignUpMode
                  ? "Sign Up / Create Account"
                  : "Sign In / Welcome Back"} */}
                Forgot password
              </h1>
              <p className="auth-subtitle">
                {/* {isSignUpMode
                  ? "Join thousands of organizations using Talent Console"
                  : "Sign in to access your talent management dashboard"} */}
                Enter your email to reset your passcode
              </p>
            </div>
            {/* Form Body */}
            <div className="auth-body">
              <form onSubmit={handleSubmit}>
                <div className="auth-field">
                  <label htmlFor="email" className="auth-label">
                    <Mail size={14} />
                    <span>Email Address*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter your email address"
                    required
                    className="auth-input"
                  />
                </div>
                {/* <button type="submit" className="auth-submit-button">
                  Send Reset Link
                </button> */}

                <button
                  className="auth-submit"
                  style={{ width: "100%", marginTop: "1rem" }}
                  //   onClick={handleLogin}
                  //   disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="spin" size={16} />
                      Signing In...
                    </>
                  ) : (
                    "Get Reset Link"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Social Completion Modal - Now rendered in portal */}
      {/* <SocialCompletionModal
        isOpen={showCompletionModal}
        userData={socialSignupData}
        onComplete={handleSocialSignupComplete}
        onClose={handleCloseModal}
        isLoading={isLoading}
      /> */}
    </div>
  );
}
